import { Model } from '@vuex-orm/core'

export default class Tag extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'tags'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      type: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Tag.js